import React, { useEffect, useState } from "react";
import { DashboardLayout } from "@/components/Layout/DashboardLayout";
import api from "@/lib/api";
import { adminNavItems } from "./_nav";
import { useLang } from "@/contexts/LanguageContext";
import { useCurrency } from "@/contexts/CurrencyContext";
import { TrendingUp, Users, Bike, UtensilsCrossed, ShoppingBag, DollarSign } from "lucide-react";

export default function AdminDashboard() {
  const { t } = useLang();
  const { formatPrice } = useCurrency();
  const [stats, setStats] = useState(null);
  useEffect(() => { api.get("/admin/stats").then(r => setStats(r.data)); }, []);

  return (
    <DashboardLayout items={adminNavItems(t)} title={t("adminStats")}>
      {!stats ? <div>Loading...</div> : (
        <>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-6 so-stagger">
            <Card icon={Users} label="Total users" value={stats.users} tid="s-users" />
            <Card icon={UtensilsCrossed} label="Restaurants" value={stats.restaurants} tid="s-restaurants" />
            <Card icon={Bike} label="Riders" value={stats.riders} tid="s-riders" />
            <Card icon={ShoppingBag} label="Orders" value={stats.orders} tid="s-orders" />
          </div>
          <div className="grid sm:grid-cols-2 gap-4">
            <Card icon={DollarSign} label={t("gmv")} value={formatPrice(stats.gmv)} tint="text-[var(--so-orange)]" big tid="s-gmv" />
            <Card icon={TrendingUp} label={t("subRevenue")} value={formatPrice(stats.subscription_revenue)} tint="text-emerald-600" big tid="s-revenue" />
          </div>
        </>
      )}
    </DashboardLayout>
  );
}

const Card = ({ icon: I, label, value, tint, big, tid }) => (
  <div className={`so-card p-5 ${big ? "p-6" : ""}`} data-testid={tid}>
    <div className="flex items-center gap-2 text-xs uppercase tracking-wider text-[var(--so-text-soft)] font-bold">
      <I className="w-4 h-4" /> {label}
    </div>
    <div className={`font-extrabold mt-2 ${big ? "text-4xl" : "text-3xl"} ${tint || ""}`}>{value}</div>
  </div>
);
